module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEbSURBVHgB7ZHbUYNQEIb3AAWkhNgBdmAqIKlArSChAQ6XAtQKYjrADkgFUgJ2EAsA/BYPM5iHjPLo5J9Zds+y++9N5N/CjEZRFNu+70OZh2Og3zRNl5DcdV0XywwYY/bB+IBo6XmelRnQSYLJ+0RHHzIDdHSadqQkFbJQUvkbooGIkXTREVLC/oSUSZL8el/W2oPnbF32Ch2iHxnx5lIix/lxXQrXJs/zvUvc6bKxX1yHCyqtxmCNU83/zMW9oSNcR+wq0LPziN35P7HX6ANVttOqSjB2r8lIha+W731aJYphvneBDaI/X/E/n43TOLOZuIejZFkWGme8Q1a2bbv2fb+E9OEs4SJ0zOFqVN9AsqPqLaKdbNC1XKH4Ane6oPCByKNEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/payment-configuration.png
// module id = 4m2B
// module chunks = 46